import { systemClockNowmqi0s7hoicxq as systemClockNow } from './InstantJs.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SystemClass;
function System() {
  if (SystemClass === VOID) {
    class $ {
      now_2cba_k$() {
        return systemClockNow();
      }
    }
    initMetadataForObject($, 'System');
    SystemClass = $;
  }
  return SystemClass;
}
var System_instance;
function System_getInstance() {
  return System_instance;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
//region block: init
System_instance = new (System())();
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Companion_instance as Companion_instancek5x5ldr4ujbk,
  System_instance as System_instance34rnn1q53nv02,
};
//endregion

//# sourceMappingURL=Clock.mjs.map
